import React from 'react';
import { connect } from 'react-redux';

import { PATH } from '../../../../constants/path';

import { HeadComponent } from '../../../HeadComponent';
import ProfileFormComponent from './ProfileFormComponent';
import UpdatePasswordFormComponent from './UpdatePasswordFormComponent';
import InterestsFormComponent from '../myinterests/InterestsFormComponent';
import LocalizedBreadcrumbItem from '../../../breadcrumb/LocalizedBreadcrumbsItem';

export class ProfilePage extends React.Component {
    render() {
        const { i18nPage, i18nHobbies } = this.props;
        return (
            <main id="p-compte-monprofil">
                <HeadComponent title={i18nPage.TITLE} description={i18nPage.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.ACCOUNT_PROFILE_PATH}>
                    {i18nPage.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h3>{i18nPage.UPDATE_INFO_TITLE}</h3>
                <ProfileFormComponent />
                <hr />
                <h3>{i18nPage.UPDATE_PASSWORD_TITLE}</h3>
                <UpdatePasswordFormComponent />
                <hr />
                <h3>{i18nHobbies.TITLE}</h3>
                <div id="p-myinterests">
                    <InterestsFormComponent />
                </div>
            </main>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18nPage: state.i18n.page.ACCOUNT.PROFILE,
        i18nHobbies: state.i18n.page.ACCOUNT.INTERESTS
    };
};

export default connect(mapStateToProps)(ProfilePage);



// WEBPACK FOOTER //
// ./src/components/pages/account/myprofile/ProfilePage.js